module.exports = __webpack_public_path__ + "static/img/screenkey1.1c52e14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/remotekey/screen/screenkey1.jpg
// module id = ecGM
// module chunks = 0